var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-avatar-container",class:{
		boilerplate: _vm.boilerplate,
		'rank-not-in-toplist': _vm.boilerplate === false && _vm.position > 20,
		'rank-in-toplist': _vm.boilerplate === false && _vm.position <= 20,
	}},[_c('v-badge',{staticClass:"my-avatar-badge",attrs:{"bottom":"","color":"green","dot":"","offset-x":"10","offset-y":"10"}},[_c('v-avatar',{staticClass:"my-avatar",attrs:{"size":"49"}},[_c('span',{staticClass:"my-avatar-name",class:{ 'ortho-text-gray': _vm.boilerplate }},[_vm._v(_vm._s(_vm.name[0]))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }